var Styles = {"tw-react--vehicle-tabs--tab--gap10":"vehicleTabs-module_tw-react--vehicle-tabs--tab--gap10__sdzVv","tw-react--vehicle-tabs--tabs":"vehicleTabs-module_tw-react--vehicle-tabs--tabs__JZD1u"};

export { Styles as default };
